import React from "react";

type ButtonProps = {
  text: string;
};
function Button({ text }: ButtonProps) {
  return (
    <button className="rounded-md py-3 whitespace-nowrap px-5 border-[1px] border-grey-300 text-grey-600">
      {text}
    </button>
  );
}

export default Button;
